<template>
  <div class="grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TileGrid',
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-auto-rows: 1fr;
  grid-gap: 1rem;
}

@media (min-width: 370px) {
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    grid-auto-rows: 1fr;
    grid-gap: 1rem;
  }
}

@media (min-width: 540px) {
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    grid-auto-rows: 1fr;
    grid-gap: 2rem;
  }
}

.grid::before {
  content: '';
  width: 0;
  padding-bottom: 100%;
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}

.grid > *:first-child:not(.grid-widget) {
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}

.grid-widget {
  grid-column: 1 / 3;
  grid-row: 1 / 3;
}

</style>
